module.exports = __webpack_public_path__ + "media/images/icons/americanexpress_small-b4e536be430c506cf40a59161c6fe281.svg";